export enum ProfileRoutes {
	get_user = "/auth/get-user/",
}
